import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ContactCardProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * 「Contact Us」通用卡片外壳：标题 + 内容，纯展示无业务逻辑。
 * 统一宽度 205px；高度由父容器（单行 items-stretch / 网格 auto-rows-fr）拉伸对齐。
 * 内容顶部对齐，保证各卡片标题在同一水平线上。
 */
export const ContactCard = ({ title, children, className }: ContactCardProps) => {
  return (
    <div
      className={twMerge(
        "flex h-[208px] w-[206px] flex-col items-center rounded-[12px] border border-kds-border bg-kds-bg shadow-[0px_4px_24px_0px_var(--kds-shadow-soft)]",
        className,
      )}
    >
      <span className="shrink-0 pt-[48px] text-center text-[16px] font-semibold leading-[24px] text-kds-fg-soft">
        {title}
      </span>
      <div className="mt-[16px] flex h-[72px] w-full flex-col items-center">{children}</div>
    </div>
  );
};
